import React from "react";
import profile from "../assets/images/navbar/profile.png";
import edit from "../assets/images/navbar/edit.png";
import address from "../assets/images/navbar/home.png";
import help from "../assets/images/navbar/help.png";
import star from "../assets/images/navbar/star.png";
import policy from "../assets/images/navbar/policy.png";
import terms from "../assets/images/navbar/terms.png";
import faq from "../assets/images/navbar/faq.png";
import info from "../assets/images/navbar/information.png";
import darkmode from "../assets/images/navbar/moon.png";
import signout from "../assets/images/navbar/logout.png";
import arrow from "../assets/images/location-modal/arrow-right.png";
import cancel from "../assets/images/navbar/cancel.png";

import { useNavigate } from "react-router-dom";
import Upgrade from "./Upgrade";
import EditProfile from "./EditProfile";
import { useTheme } from "../context/ThemeContext";
import { authService, UserProfile } from "../services";
import socketClient from "../utils/socketClient";
import { useAuth } from "../context/AuthContext";

type ProfileProps = {
  setIsUserModalOpen: (open: boolean) => void;
};

const Profile = ({ setIsUserModalOpen }: ProfileProps) => {
  const [isEdit, setIsEdit] = React.useState(false);
  const [isUpgrade, setIsUpgrade] = React.useState(false);
  const [userProfile, setUserProfile] = React.useState<UserProfile | null>(null);
  const [loading, setLoading] = React.useState(true);
  const navigate = useNavigate();
  const { isDarkMode, toggleDarkMode } = useTheme();
  const { setIsAuthenticated } = useAuth();

  // Fetch user profile on mount
  React.useEffect(() => {
    const fetchProfile = async () => {
      try {
        const response: any = await authService.getUserProfile();
        if (response.status && response.data) {
          setUserProfile(response.data);
        }
      } catch (error) {
        console.error("Failed to fetch user profile:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchProfile();
  }, []);

  const refreshProfile = async () => {
    try {
      const response: any = await authService.getUserProfile();
      if (response.status && response.data) {
        setUserProfile(response.data);
      }
    } catch (error) {
      console.error("Failed to refresh user profile:", error);
    }
  };

  return (
    <div>
      <div
        className="fixed inset-0 bg-black bg-opacity-50 z-50 transition-opacity duration-300"
        onClick={() => setIsUserModalOpen(false)}
      >
        <div
          className="fixed right-0 top-0 h-full w-full max-w-[450px] bg-white dark:bg-gray-800 shadow-2xl transform transition-transform duration-300 ease-in-out rounded-l-[20px] p-6 shadow-[-23px_0_72px_0_rgba(0,0,0,0.15)] gap-6 overflow-y-auto"
          style={{ animation: "slideInRight 0.3s ease-out" }}
          onClick={(e) => e.stopPropagation()}
        >
          {/* Modal Header */}
          <div className="flex justify-between items-center">
            <img
              src={cancel}
              alt="close"
              className="flex w-[36px] h-[36px] p-[7.5px] justify-center items-center gap-[7.5px] shrink-0 rounded-full border-[0.75px] border-[rgba(112,107,102,0.25)] bg-[rgba(255,255,255,0.25)] dark:bg-gray-700 dark:border-gray-600 cursor-pointer dark:invert"
              onClick={() => setIsUserModalOpen(false)}
            />
          </div>

          {/* Modal Content */}
          <div className="space-y-6 mt-[24px] pb-20">
            {/* User Info */}
            <div className="rounded-[16px] border dark:border-gray-700">
              <div className="flex justify-between items-center gap-4 p-[16px]">
                <div className="rounded-full flex items-center justify-center gap-[12px] ">
                  <img 
                    src={userProfile?.image || profile} 
                    alt="User" 
                    className="h-[72px] w-[72px] rounded-full object-cover" 
                  />
                  <div>
                    <h6 className="text-[#050505] dark:text-white font-urbanist text-[22px] font-semibold leading-[140%]">
                      {loading ? "Loading..." : `${userProfile?.firstName || ""} ${userProfile?.lastName || ""}`}
                    </h6>
                    <p className="text-[#6A6A6A] dark:text-gray-400 font-urbanist text-[14px] font-medium leading-[20px]">
                      {userProfile?.phoneNumber || "+91 9876543210"}
                    </p>
                    {userProfile?.email && (
                      <p className="text-[#6A6A6A] dark:text-gray-400 font-urbanist text-[12px] font-medium leading-[18px]">
                        {userProfile.email}
                      </p>
                    )}
                    {userProfile?.city && userProfile?.state && (
                      <p className="text-[#6A6A6A] dark:text-gray-400 font-urbanist text-[12px] font-medium leading-[18px] mt-1 flex items-center gap-1">
                        <span className="text-[#7402A7] dark:text-purple-400">📍</span>
                        {userProfile.city}, {userProfile.state}
                      </p>
                    )}
                  </div>
                </div>
                <div
                  className="flex items-center py-[7.5px] px-[9px] gap-[6px] rounded-[7.5px] border-[0.75px] border-[#E9E9E9] dark:border-gray-600 bg-[#F5F5F5] dark:bg-gray-700 cursor-pointer"
                  onClick={() => setIsEdit(!isEdit)}
                >
                  <img
                    src={edit}
                    alt="Edit"
                    className="h-[12px] w-[12px] cursor-pointer dark:invert"
                  />
                  <p className="text-[#050505] dark:text-white text-center font-urbanist text-[12px] font-medium leading-[15px]">
                    Edit
                  </p>
                </div>
              </div>
              <div
                className="flex  h-[60px] py-[12px] px-4 justify-between items-center gap-[10px] bg-[#7402A7] rounded-b-[16px]"
                onClick={() => setIsUpgrade(!isUpgrade)}
              >
                <div>
                  <p className="text-white font-urbanist text-[14px] font-medium leading-[140%]">
                    Upgrade to Duddus+
                  </p>
                  <p className="text-white font-urbanist text-[10px] font-medium leading-[16px] mt-1">
                    Get Exclusive Offers, Free food delivery and much more
                  </p>
                </div>
                <div className="flex items-center py-[7.5px] px-[9px] gap-[6px] rounded-[7.5px] border-[0.75px] border-[#E9E9E9] bg-[#FFFEFD]">
                  <button>Upgrade</button>
                </div>
              </div>
            </div>

            {/* Menu Items */}
            <div className="border dark:border-gray-700 rounded-[16px] p-4">
              <div 
                className="flex justify-between items-center gap-4 rounded-lg hover:bg-gray-50 dark:hover:bg-gray-700 cursor-pointer transition-colors"
                onClick={() => {
                  navigate("/saved-addresses");
                  setIsUserModalOpen(false);
                }}
              >
                <div className="flex items-center gap-[8px]">
                  <img src={address} alt="Home" className="h-[20px] w-[20px] dark:invert" />
                  <span className="text-[#040404] dark:text-white font-urbanist text-[16px] font-medium leading-[20px]">
                    Manage Address
                  </span>
                </div>
                <div>
                  <img src={arrow} alt="arrow" className="h-[18px] w-[18px] dark:invert" />
                </div>
              </div>

              <div className="h-[1px] w-full bg-gray-300 dark:bg-gray-600 my-[20px]"></div>

              <div
                className="flex justify-between items-center gap-4 rounded-lg hover:bg-gray-50 dark:hover:bg-gray-700 cursor-pointer transition-colors "
                onClick={() => {
                  navigate("/orders");
                  setIsUserModalOpen(false);
                }}
              >
                <div className="flex items-center gap-[8px]">
                  <img src={address} alt="Home" className="h-[20px] w-[20px] dark:invert" />
                  <span className="text-[#040404] dark:text-white font-urbanist text-[16px] font-medium leading-[20px]">
                    My Orders
                  </span>
                </div>
                <div>
                  <img src={arrow} alt="arrow" className="h-[18px] w-[18px] dark:invert" />
                </div>
              </div>

              <div className="h-[1px] w-full bg-gray-300 dark:bg-gray-600 my-[20px]"></div>

              <div className="flex justify-between items-center gap-4 rounded-lg hover:bg-gray-50 dark:hover:bg-gray-700 cursor-pointer transition-colors ">
                <div
                  className="flex items-center gap-[8px]"
                  onClick={() => {
                    navigate("/help-and-support");
                    setIsUserModalOpen(false);
                  }}
                >
                  <img src={help} alt="Help" className="h-[20px] w-[20px] dark:invert" />
                  <span className="text-[#040404] dark:text-white font-urbanist text-[16px] font-medium leading-[20px]">
                    Help and Support
                  </span>
                </div>
                <div>
                  <img src={arrow} alt="arrow" className="h-[18px] w-[18px] dark:invert" />
                </div>
              </div>

              <div className="h-[1px] w-full bg-gray-300 dark:bg-gray-600 my-[20px]"></div>
              <div
                className="flex justify-between items-center gap-4 rounded-lg hover:bg-gray-50 dark:hover:bg-gray-700 cursor-pointer transition-colors "
                onClick={() => {
                  navigate("/rate-us");
                  setIsUserModalOpen(false);
                }}
              >
                <div className="flex items-center gap-[8px]">
                  <img src={star} alt="Rate Us" className="h-[20px] w-[20px] dark:invert" />
                  <span className="text-[#040404] dark:text-white font-urbanist text-[16px] font-medium leading-[20px]">
                    Rate Us
                  </span>
                </div>
                <div>
                  <img src={arrow} alt="arrow" className="h-[18px] w-[18px] dark:invert" />
                </div>
              </div>

              <div className="h-[1px] w-full bg-gray-300 dark:bg-gray-600 my-[20px]"></div>

              <div
                className="flex justify-between items-center gap-4 rounded-lg hover:bg-gray-50 dark:hover:bg-gray-700 cursor-pointer transition-colors "
                onClick={() => {
                  navigate("/terms-and-conditions");
                  setIsUserModalOpen(false);
                }}
              >
                <div className="flex items-center gap-[8px]">
                  <img src={terms} alt="terms" className="h-[20px] w-[20px] dark:invert" />
                  <span className="text-[#040404] dark:text-white font-urbanist text-[16px] font-medium leading-[20px]">
                    Terms and Conditions
                  </span>
                </div>
                <div>
                  <img src={arrow} alt="arrow" className="h-[18px] w-[18px] dark:invert" />
                </div>
              </div>

              <div className="h-[1px] w-full bg-gray-300 dark:bg-gray-600 my-[20px]"></div>

              <div
                className="flex justify-between items-center gap-4 rounded-lg hover:bg-gray-50 dark:hover:bg-gray-700 cursor-pointer transition-colors "
                onClick={() => {
                  navigate("/faqs");
                  setIsUserModalOpen(false);
                }}
              >
                <div className="flex items-center gap-[8px]">
                  <img src={faq} alt="FAQ" className="h-[20px] w-[20px] dark:invert" />
                  <span className="text-[#040404] dark:text-white font-urbanist text-[16px] font-medium leading-[20px]">
                    FAQs
                  </span>
                </div>
                <div>
                  <img src={arrow} alt="arrow" className="h-[18px] w-[18px] dark:invert" />
                </div>
              </div>

              <div className="h-[1px] w-full bg-gray-300 dark:bg-gray-600 my-[20px]"></div>

              <div
                className="flex justify-between items-center gap-4 rounded-lg hover:bg-gray-50 dark:hover:bg-gray-700 cursor-pointer transition-colors "
                onClick={() => {
                  navigate("/about-us");
                  setIsUserModalOpen(false);
                }}
              >
                <div className="flex items-center gap-[8px]">
                  <img
                    src={info}
                    alt="About Us"
                    className="h-[20px] w-[20px] dark:invert"
                  />
                  <span className="text-[#040404] dark:text-white font-urbanist text-[16px] font-medium leading-[20px]">
                    About Us
                  </span>
                </div>
                <div>
                  <img src={arrow} alt="arrow" className="h-[18px] w-[18px] dark:invert" />
                </div>
              </div>

              <div className="h-[1px] w-full bg-gray-300 dark:bg-gray-600 my-[20px]"></div>

              <div
                className="flex justify-between items-center gap-4 rounded-lg hover:bg-gray-50 dark:hover:bg-gray-700 cursor-pointer transition-colors "
                onClick={() => {
                  navigate("/privacy-policy");
                  setIsUserModalOpen(false);
                }}
              >
                <div className="flex items-center gap-[8px]">
                  <img
                    src={policy}
                    alt="Privacy Policy"
                    className="h-[20px] w-[20px] dark:invert"
                  />
                  <span className="text-[#040404] dark:text-white font-urbanist text-[16px] font-medium leading-[20px]">
                    Privacy Policy
                  </span>
                </div>
                <div>
                  <img src={arrow} alt="arrow" className="h-[18px] w-[18px] dark:invert" />
                </div>
              </div>

              <div className="h-[1px] w-full bg-gray-300 dark:bg-gray-600 my-[20px]"></div>
              <div 
                className="flex justify-between items-center gap-4 rounded-lg hover:bg-gray-50 dark:hover:bg-gray-700 cursor-pointer transition-colors"
                onClick={toggleDarkMode}
              >
                <div className="flex items-center gap-[8px]">
                  <img
                    src={darkmode}
                    alt="Dark Mode"
                    className="h-[20px] w-[20px] dark:invert"
                  />
                  <span className="text-[#040404] dark:text-white font-urbanist text-[16px] font-medium leading-[20px]">
                    Dark Mode
                  </span>
                </div>
                <div>
                  {/* Toggle Switch */}
                  <div className={`w-[44px] h-[24px] flex items-center rounded-full p-1 cursor-pointer transition-colors duration-300 ${isDarkMode ? 'bg-[#7402A7]' : 'bg-gray-300'}`}>
                    <div className={`bg-white w-[16px] h-[16px] rounded-full shadow-md transform transition-transform duration-300 ${isDarkMode ? 'translate-x-5' : 'translate-x-0'}`}></div>
                  </div>
                </div>
              </div>

              <div className="h-[1px] w-full bg-gray-300 dark:bg-gray-600 my-[20px]"></div>

              <div 
                className="flex justify-between items-center gap-4 rounded-lg hover:bg-gray-50 dark:hover:bg-gray-700 cursor-pointer transition-colors"
                onClick={() => {
                  socketClient.disconnect();
                  localStorage.removeItem('authToken');
                  setIsAuthenticated(false);
                  setIsUserModalOpen(false);
                  window.location.href = '/';
                }}
              >
                <div className="flex items-center gap-[8px]">
                  <img
                    src={signout}
                    alt="Sign Out"
                    className="h-[20px] w-[20px] dark:invert"
                  />
                  <span className="text-[#040404] dark:text-white font-urbanist text-[16px] font-medium leading-[20px]">
                    Sign Out
                  </span>
                </div>
                <div>
                  <img src={arrow} alt="arrow" className="h-[18px] w-[18px] dark:invert" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Edit Profile Modal */}
      {isEdit && userProfile && (
        <EditProfile 
          setIsEdit={setIsEdit} 
          userProfile={userProfile}
          onProfileUpdate={refreshProfile}
        />
      )}

      {/* dudus + */}
      {isUpgrade && <Upgrade setIsUpgrade={setIsUpgrade} />}
    </div>
  );
};

export default Profile;
